<template>
  <div class="container main has-submenu" :class="{ fullwidth : !loggedIn }">
    <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <div class="panel panel-info">
      <div class="wrapper">
        <div class="banner">
          <h3 style="text-align:center;">Your Cards</h3>
            <card></card>
            <div class="floating-button action-button"  title="Add a new Cards" @click="addCards">
            +
            </div>
          </div>
      </div>
    </div>
        <div id="add_creditcards" class="modal" data-easein="pulse" tabindex="-1" role="dialog" aria-labelledby="addbankLabel" aria-hidden="false">
            <!-- CREDIT CARD FORM STARTS HERE -->
            <div class="payment panel panel-default credit-card-box">
                <div class="panel-heading display-table" >
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">X</button>
                    <div class="row display-tr" >
                        <!--<h3 class="panel-title display-td" >Add debit or credit card</h3>-->
                        <h4 style="text-align:center">Add credit / debit card</h4>
                        <div>
                            <img class="img-responsive" style="margin-left:auto; margin-right:auto;" src="../../../static/img/creditCard.png">
                        </div>
                    </div>
                </div>
                <div class="panel-body">
                    <form role="form" id="payment-form" method="POST" action="javascript:void(0);">
                        <div class="row">
                            <div class="col-xs-12">
                                <div class="form-group">
                                    <label for="cardNumber">CARD NUMBER</label>
                                    <div class="input-group">
                                        <input
                                            v-model.trim="cardNumber"
                                            type="tel"
                                            class="form-control"
                                            name="cardNumber"
                                            placeholder="Valid Card Number"
                                            autocomplete="cc-number"
                                            required autofocus
                                        />
                                        <span class="input-group-addon"><i class="fa fa-credit-card"></i></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-6 col-md-6">
                                <div class="form-group">
                                    <label for="cardExpiry"><span class="hidden-xs">EXPIRATION</span><span class="visible-xs-inline">EXP</span> DATE</label>
                                    <input
                                        v-model.trim="cardExpiry"
                                        type="tel"
                                        class="form-control"
                                        name="cardExpiry"
                                        placeholder="MM / YY"
                                        autocomplete="cc-exp"
                                        required
                                    />
                                </div>
                            </div>
                            <div class="col-xs-6 col-md-4 pull-right">
                                <div class="form-group">
                                    <label for="cardCVC">CV CODE</label>
                                    <input
                                        type="tel"
                                        v-model.trim="cardCVC"
                                        class="form-control"
                                        name="cardCVC"
                                        placeholder="CVC"
                                        autocomplete="cc-csc"
                                        required
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="row">
                          <div class="col-xs-12">
                                <div class="form-group">
                                    <label for="name">NAME</label>
                                    <input
                                        type="text"
                                        v-model.trim="name"
                                        class="form-control"
                                        name="name"
                                        placeholder="NAME"
                                        required
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="row">
                          <div class="col-xs-6">
                                <div class="form-group">
                                    <label for="address_city">CITY</label>
                                    <input
                                        type="text"
                                        v-model.trim="address_city"
                                        class="form-control"
                                        name="address_city"
                                        placeholder="CITY"
                                        required
                                    />
                                </div>
                            </div>
                            <div class="col-xs-6">
                                <div class="form-group">
                                    <label for="address_country">COUNTRY</label>
                                    <input
                                        type="text"
                                        v-model.trim="address_country"
                                        class="form-control"
                                        name="address_country"
                                        placeholder="COUNTRY"
                                        required
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="row">
                          <div class="col-xs-6">
                                <div class="form-group">
                                    <label for="address_line1">Adress 1</label>
                                    <input
                                        type="text"
                                        v-model.trim="address_line1"
                                        class="form-control"
                                        name="address_line1"
                                        placeholder="Adress 1"
                                        required
                                    />
                                </div>
                            </div>
                            <div class="col-xs-6">
                                <div class="form-group">
                                    <label for="address_line2">Adress 2</label>
                                    <input
                                        type="text"
                                        v-model.trim="address_line2"
                                        class="form-control"
                                        name="address_line2"
                                        placeholder="Adress 2"
                                        required
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="row">
                          <div class="col-xs-6">
                                <div class="form-group">
                                    <label for="address_line1">State</label>
                                    <input
                                        type="text"
                                        v-model.trim="address_state"
                                        class="form-control"
                                        name="address_state"
                                        placeholder="address_state"
                                        required
                                    />
                                </div>
                            </div>
                            <div class="col-xs-6">
                                <div class="form-group">
                                    <label for="address_zip">ZIP</label>
                                    <input
                                        type="tel"
                                        v-model.trim="address_zip"
                                        class="form-control"
                                        name="address_line2"
                                        placeholder="ZIP"
                                        required
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-12">
                                <button class="subscribe btn btn-success btn-lg btn-block" type="button" @click="addCreditCard">Add Card</button>
                            </div>
                        </div>
                        <div class="row" style="display:none;">
                            <div class="col-xs-12">
                                <p class="payment-errors"></p>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <!-- CREDIT CARD FORM ENDS HERE -->
        </div> <!-- modal End Add MonCash-->
  </div>
  </div>
</div>
</template>
<script>
  // import Vue from 'vue'
  import card from './Card'
  import { default as swal } from 'sweetalert2'
  import {HTTP, account} from '../../services/account-services.js'
  export default {
    name: 'Cards',
    components: {
      card
    },
    data() {
      return {
        cardNumber: '',
        cardExpiry: '',
        cardCVC: '',
        name: '',
        address_city: '',
        address_country: '',
        address_line1: '',
        address_line2: '',
        address_state: '',
        address_zip: '',
        stripeID: '',
        account: {}
      }
    },
    methods: {
      resetFormData() {
        $('input[name=cardNumber]').value('')
        $('input[name=cardExpiry]').value('')
        $('input[name=name]').value('')
        // this.cardNumber = ''
        // this.cardExpiry = ''
        // this.cardCVC = ''
        // this.name = ''
        // this.address_city = ''
        // this.address_country = ''
        // this.address_line1 = ''
        // this.address_line2 = ''
        // this.address_state = ''
        // this.address_zip = ''
      },
      addCards() {
        $('#add_creditcards').modal()
      },
      addCreditCard() {
        var $form = $('#payment-form')
        var expiry = $form.find('[name=cardExpiry]').payment('cardExpiryVal')
        let cardNumber = this.cardNumber.replace(/\s/g, '')
        // let cardExpiry = String(this.cardExpiry.toString)
        let month = String('0' + expiry.month)
        let year = String(expiry.year)
        let cvc = this.cardCVC
        let name = this.name
        let addressCity = this.address_city
        let addressCountry = this.address_country
        let addressLine1 = this.address_line1
        let addressLine2 = this.address_line2
        let addressState = this.address_state
        let addressZip = this.address_zip
        let token = localStorage.getItem('authToken')
        let accountID = localStorage.getItem('userId')
        let url = `/accounts/${accountID}/cards?access_token=${token}`
        HTTP.post(url, {
          object: 'card',
          exp_month: month,
          exp_year: year,
          number: cardNumber,
          cvc: cvc,
          name: name,
          address_city: addressCity,
          address_country: addressCountry,
          address_line1: addressLine1,
          address_line2: addressLine2,
          address_state: addressState,
          address_zip: addressZip
        }).then((response) => {
          console.log(response)
          $('#add_creditcards').modal('hide')
          swal(
            'Success !',
            'Your card has been added succesfully!',
            'success'
          ).then((result) => {
            this.$router.push('/account')
          })
        }).catch((e) => {
          console.error(e)
          swal(
            'Error',
            'Your card was declined. Please contact your provider for more details.',
            'error'
          ).then((result) => {
            this.$router.push('/account/link')
            $('#add_creditcards').modal('hide')
            this.resetFormData()
          })
        })
      }
    },
    beforeMount() {
      if (!localStorage.getItem('authToken')) {
        return this.$router.push('/login')
      }
      setTimeout(() => {
        this.loading = false
      }, 2000)
    },
    mounted() {
      let app = this
      account().then(function(response) {
        app.stripeID = response.stripeCustomerId
      }).catch(function(e) {
        console.error(e)
      })
      /* global Stripe */
      var $form = $('#payment-form')
      $form.find('.subscribe').on('click', payWithStripe)
      /* If you're using Stripe for payments */
      function payWithStripe(e) {
        e.preventDefault()

        let validator

        validator = $form.validate({
          rules: {
            cardNumber: {
              required: true,
              cardNumber: true
            },
            cardExpiry: {
              required: true,
              cardExpiry: true
            },
            cardCVC: {
              required: true,
              cardCVC: true
            }
          },
          highlight: function(element) {
            $(element).closest('.form-control').removeClass('success').addClass('error')
          },
          unhighlight: function(element) {
            $(element).closest('.form-control').removeClass('error').addClass('success')
          },
          errorPlacement: function(error, element) {
            $(element).closest('.form-group').append(error)
          }
        })

        /* Abort if invalid form data */
        if (!validator.form()) {
          return
        }

        /* Visual feedback */
        $form
          .find('.subscribe')
          .html('Validating <i class="fa fa-spinner fa-pulse"></i>')
          .prop('disabled', true)

        var PublishableKey = 'pk_test_1gJfAA34FfdhB6fLqtsJfNCi'
        Stripe.setPublishableKey(PublishableKey)
      }

      /* Fancy restrictive input formatting via jQuery.payment library */
      $('input[name=cardNumber]').payment('formatCardNumber')
      $('input[name=cardCVC]').payment('formatCardCVC')
      $('input[name=cardExpiry').payment('formatCardExpiry')

      /* Form validation using Stripe client-side validation helpers */
      jQuery.validator.addMethod('cardNumber', function(value, element) {
        return this.optional(element) || Stripe.card.validateCardNumber(value)
      }, 'Please specify a valid credit card number.')

      jQuery.validator.addMethod('cardExpiry', function(value, element) {
        /* Parsing month/year uses jQuery.payment library */
        value = $.payment.cardExpiryVal(value)
        return this.optional(element) || Stripe.card.validateExpiry(value.month, value.year)
      }, 'Invalid expiration date.')

      jQuery.validator.addMethod('cardCVC', function(value, element) {
        return this.optional(element) || Stripe.card.validateCVC(value)
      }, 'Invalid CVC.')

      let paymentFormReady
      paymentFormReady = function() {
        if ($form.find('[name=cardNumber]').hasClass('success') &&
            $form.find('[name=cardExpiry]').hasClass('success') &&
            $form.find('[name=cardCVC]').val().length > 1) {
          return true
        } else {
          return false
        }
      }

      $form.find('.subscribe').prop('disabled', true)
      var readyInterval = setInterval(function() {
        if (paymentFormReady()) {
          $form.find('.subscribe').prop('disabled', false)
          clearInterval(readyInterval)
        }
      }, 250)
    },
    props: ['loggedIn']
  }
</script>
<style scoped>
  .wrapper {
    width: 100%;
    font-family: 'Helvetica';
    font-size: 14px;
    margin-top: 30px;
    /*border: 1px solid #CCC*/
  }
.banner{
    /*position: fixed*/
    font-family: 'PayPal-Sans-Big', sans-serif;
    text-align: left;
}
.link{
    width: 40%;
    padding-left:10%;
    border-radius: 6px;
    background-color: transparent;
    border: solid 1px #e1e7eb;
    vertical-align: middle;
    text-align: center;
    display: table-cell;
    cursor: pointer;
}
.link:hover{
  border: solid 1px #009bde;
}
.active{
  border: solid 2px #009bde;
}
.link img{
  margin-top :20px;

}
.link p{
  margin-left:10px;
  margin-right: 10px;
  font-size:12px;
}
.addSection a{
  text-decoration: none;
}
.addSection a:hover{
  color: white;
}

@media (min-width: 480px) {
  .link img{
    margin-left: auto;
    margin-right:auto;
    margin-top:20px;
  }
  .welcome {
  text-align: center;
  margin-top: -70px;
  }
  .wrapper {
    padding: 15px;
  }
  .addSection{
  display: flex;
  justify-content: space-between;
  margin-right: auto;
  margin-left: auto;
  }
}
@media (max-width: 480px) {
  .banner{
    padding: 0.5em 0.5em 0.5em;
  }
  .welcome {
  text-align: center;
  margin-top: -30px;
  }
  .link img{
    margin-left: auto;
    margin-right:auto;
  }
  .addSection {
  display: flex;
  flex-direction: column;
  margin-right: auto;
  margin-left: auto;
  width:100%
  }
}

.floating-button {
  position: fixed;
  z-index: 100;
  width: 50px;
  height: 50px;
  background: #E91E63;
  color: #FFF;
  font-size: 2em;
  border-radius: 50%;
  top: 20vh;
  right: 50px;
  margin-top: -25px;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-flex-direction: column;
  flex-direction: column;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.26);
  -moz-box-shadow: 0 2px 5px rgba(0, 0, 0, 0.26);
  -webkit-box-shadow: 0 2px 5px rgba(0, 0, 0, 0.26);
  -webkit-transition: all 0.3s linear;
  -o-transition: all 0.3s linear;
  -moz-transition: all 0.3s linear;
  -ms-transition: all 0.3s linear;
  -kthtml-transition: all 0.3s linear;
  transition: all 0.3s linear;
}

.floating-button:hover {
  box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.3);
  -moz-box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.3);
  margin-top: -30px;
}

.floating-button:active {
  box-shadow: 0 10px 15px 0 rgba(0, 0, 0, 0.4);
  -moz-box-shadow: 0 10px 15px 0 rgba(0, 0, 0, 0.4);
  -webkit-box-shadow: 0 10px 15px 0 rgba(0, 0, 0, 0.4);
  margin-top: -32px;
  background: #EC407A;
}

@media screen and (max-width: 600px) {
  header {
    height: 50vh;
  }
  .floating-button {
    top: 90vh;
    bottom: 10px;
    right: 30px !important;
  }
  .icon {
    display: block
  }
  section h1 {
    margin: 30px 0 0 0;
  }
  .added h1 {
    padding-top: 15px;
  }
}

@media screen and (max-width: 1200px) {
  .floating-button {
    right: 10px;
  }
}


  /* floating buuton */
  /* CSS for Credit Card Payment form */
.credit-card-box .panel-title {
    display: inline;
    font-weight: bold;
}
.credit-card-box .form-control.error {
    border-color: red;
    outline: 0;
    box-shadow: inset 0 1px 1px rgba(0,0,0,0.075),0 0 8px rgba(255,0,0,0.6);
}
.credit-card-box label.error {
  font-weight: bold;
  color: red;
  padding: 2px 8px;
  margin-top: 2px;
}
.credit-card-box .payment-errors {
  font-weight: bold;
  color: red;
  padding: 2px 8px;
  margin-top: 2px;
}
.credit-card-box label {
    display: block;
}
/* The old "center div vertically" hack */
.credit-card-box .display-table {
    display: table;
}
.credit-card-box .display-tr {
    display: table-row;
}
.credit-card-box .display-td {
    display: table-cell;
    vertical-align: middle;
    width: 50%;
}
/* Just looks nicer */
.credit-card-box .panel-heading img {
    min-width: 180px;
}
.panel-default .panel-heading {
    background-color: #f5f5f5 !important;
    color: #5d5d5d !important;
    width: 100% !important;
}
@media (max-width: 480px) {
.col-xs-6 {
    padding-left: 5px !important;
    padding-right: 0 !important;
  }
}

.form-group input[placeholder] {
    color: #555 !important;
    font-size: 16px !important;
}
input[type=text]{
  border-radius: 5px;
  padding: 12px 10px;
  height: 37px;
  border: 2px solid #9fc7c0;
}
</style>



// WEBPACK FOOTER //
// src/components/Cards/Cards.vue